/* HEARTBOOK quantity tiles. Nguồn: HQ-Groups brands/heartbook/store/pdp-top-2026-09-25/
   Ô chỉ ghi vào ô số lượng GỐC của Shrine (input[name="quantity"] trong form), rồi báo 'input' + 'change'.
   Nạp async, không chờ js.shrinetheme.com/main.js: khách bấm lúc Shrine chưa tải thì số lượng vẫn vào form. */
(function () {
  const define = () => {
    // 28/09 founder: lời khách dài bị cắt 3 dòng -> "Read more" mở popup đọc trọn (nguyên văn).
    // - Nút chỉ hiện khi chữ THẬT SỰ bị cắt (đo scrollHeight), đo lại khi đổi cỡ màn / font tải xong. Không vòng lặp.
    // - Popup là <dialog> showModal: nổi trên mọi lớp, Esc đóng, giữ tiêu điểm. Chạm nền mờ hoặc X để đóng.
    // - Nút Back (vuốt lùi trên điện thoại) ĐÓNG popup, không rời trang: mở thì pushState, Back -> popstate -> đóng;
    //   đóng bằng X / Esc / nền thì tự lùi lại mục lịch sử đã thêm.
    // - Trình duyệt không có showModal: không hiện nút (như trước 28/09).
    if (!customElements.get('hb-quotes')) {
      customElements.define(
        'hb-quotes',
        class HbQuotes extends HTMLElement {
          connectedCallback() {
            this.dlg = this.querySelector('.hb-qdlg');
            if (!this.dlg || typeof this.dlg.showModal !== 'function') return;
            this.items = [...this.querySelectorAll('.hb-quote')].map((li) => ({
              li,
              q: li.querySelector('.hb-quote__text'),
              btn: li.querySelector('.hb-quote__more'),
              by: li.querySelector('.hb-quote__by > span'),
            }));
            this.measure = this.measure.bind(this);
            this.onPop = this.onPop.bind(this);
            // e.detail > 0 = bấm bằng chạm/chuột; 0 = Enter/Space từ bàn phím
            this.items.forEach((it, i) => it.btn && it.btn.addEventListener('click', (e) => this.open(i, e.detail > 0)));
            this.dlg.querySelector('.hb-qdlg__close').addEventListener('click', () => this.dlg.close());
            this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.dlg.close(); }); // chạm nền mờ
            this.dlg.addEventListener('close', () => this.onClose());
            window.addEventListener('popstate', this.onPop);
            if ('ResizeObserver' in window) {
              this.ro = new ResizeObserver(this.measure);
              this.items.forEach((it) => it.q && this.ro.observe(it.q));
            }
            this.measure();
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.measure);
          }
          disconnectedCallback() {
            if (this.ro) this.ro.disconnect();
            window.removeEventListener('popstate', this.onPop);
          }
          measure() {
            this.items.forEach((it) => {
              if (!it.q || !it.btn) return;
              it.btn.hidden = !(it.q.scrollHeight > it.q.clientHeight + 1);
            });
          }
          open(i, byPointer) {
            const it = this.items[i];
            if (!it || this.dlg.open) return;
            this.last = it.btn;
            this.byPointer = !!byPointer;
            this.dlg.querySelector('.hb-qdlg__text').textContent = it.q.textContent.trim();
            const by = this.dlg.querySelector('.hb-qdlg__by');
            by.textContent = '';
            if (it.by) by.appendChild(it.by.cloneNode(true));
            this.dlg.showModal();
            this.dlg.querySelector('.hb-qdlg__panel').scrollTop = 0;
            document.documentElement.classList.add('hb-q-open');
            try {
              history.pushState(Object.assign({}, history.state, { hbQuote: 1 }), '');
              this.pushed = true;
            } catch (e) {
              this.pushed = false;
            }
          }
          onPop() {
            if (!this.dlg.open) return;
            this.pushed = false; // mục lịch sử đã được Back lấy đi
            this.dlg.close();
          }
          onClose() {
            document.documentElement.classList.remove('hb-q-open');
            // mở bằng chạm/chuột: trình duyệt trả tiêu điểm về chỗ cũ rồi vẽ khung -> bỏ luôn (founder 28/09 không muốn vòng focus).
            // Safari iPhone không đặt tiêu điểm vào nút khi chạm mà vào DẢI lời khách (ul tabindex=0) -> bỏ tiêu điểm của bất cứ
            // thứ gì trong khối, không chỉ nút (đo bằng quote_focus_webkit.mjs). Mở bằng bàn phím: giữ tiêu điểm cho người dùng bàn phím.
            if (this.byPointer) setTimeout(() => { const a = document.activeElement; if (a && a !== document.body && this.contains(a)) a.blur(); }, 0);
            if (this.pushed) {
              this.pushed = false;
              if (history.state && history.state.hbQuote) history.back();
            }
          }
        }
      );
    }
    // "What's inside": số trang theo bản đang chọn (bảng "Tên bản=số trang" do founder xác nhận)
    if (!customElements.get('hb-facts')) {
      customElements.define(
        'hb-facts',
        class HbFacts extends HTMLElement {
          connectedCallback() {
            const read = (sel) => {
              try {
                return JSON.parse(this.querySelector(sel).textContent);
              } catch (e) {
                return {};
              }
            };
            this.map = read('[data-hb-facts-map]');
            this.titles = read('[data-hb-facts-variants]');
            this.form = document.getElementById(this.dataset.formId);
            this.n = this.querySelector('.hb-facts__n');
            this.last = '';
            this.sync();
            this.timer = setInterval(() => { if (!document.hidden) this.sync(); }, 400); // 27/09 audit C14: không chạy khi tab ẩn
          }
          disconnectedCallback() {
            clearInterval(this.timer);
          }
          sync() {
            const input = this.form && this.form.querySelector('input[name="id"]');
            const id = input ? String(input.value) : '';
            if (!id || id === this.last || !this.n) return;
            this.last = id;
            const title = this.titles[id];
            this.n.textContent = title != null && this.map[title] != null ? this.map[title] : this.dataset.default;
          }
        }
      );
    }
    if (customElements.get('hb-qty-tiles')) return;
    customElements.define(
      'hb-qty-tiles',
      class HbQtyTiles extends HTMLElement {
        connectedCallback() {
          const wrap = document.getElementById(this.dataset.qtyId);
          this.input = wrap && wrap.querySelector('input[name="quantity"]');
          if (!this.input) return; // không có ô số lượng gốc thì để nguyên giao diện Shrine
          this.form = document.getElementById(this.dataset.formId);
          this.threshold = Number(this.dataset.threshold || 0);
          this.format = this.dataset.moneyFormat || '${{amount}}';
          try {
            this.variants = JSON.parse(this.querySelector('[data-hb-qty-variants]').textContent);
          } catch (e) {
            this.variants = [];
          }
          this.tiles = Array.from(this.querySelectorAll('.hb-qty__tile'));
          this.more = this.querySelector('.hb-qty__more');
          this.val = this.querySelector('.hb-qty__val');
          this.moreTotal = this.querySelector('.hb-qty__more-total');

          this.tiles.forEach((t, i) => {
            t.addEventListener('click', () => this.set(Number(t.dataset.qty)));
            t.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              e.preventDefault();
              const next = this.tiles[(i + (e.key === 'ArrowRight' ? 1 : this.tiles.length - 1)) % this.tiles.length];
              next.focus();
              next.click();
            });
          });
          this.querySelectorAll('[data-step]').forEach((b) =>
            b.addEventListener('click', () => this.set(Math.max(4, this.qty + Number(b.dataset.step))))
          );

          this.qty = Math.max(1, parseInt(this.input.value, 10) || 1);
          this.variantId = this.currentVariantId();
          this.renderPrices();
          this.render();
          // đồng bộ khi thứ khác đổi số lượng hoặc bản (Shrine, thanh dính, app)
          this.timer = setInterval(() => { if (!document.hidden) this.sync(); }, 400); // 27/09 audit C14: không chạy khi tab ẩn
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        currentVariantId() {
          const id = this.form && this.form.querySelector('input[name="id"]');
          return id ? String(id.value) : '';
        }

        price() {
          const v = this.variants.find((x) => String(x.id) === this.variantId) || this.variants[0];
          return v ? Number(v.cents) : 0;
        }

        money(cents) {
          const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return this.format
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
            .replace(/\{\{\s*amount\s*\}\}/, amount);
        }

        set(q) {
          this.qty = Math.max(1, Math.min(99, q));
          this.input.value = String(this.qty);
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.render();
        }

        sync() {
          const q = Math.max(1, parseInt(this.input.value, 10) || 1);
          if (q !== this.qty) {
            this.qty = q;
            this.render();
          }
          const id = this.currentVariantId();
          if (id && id !== this.variantId) {
            this.variantId = id;
            this.renderPrices();
            this.render();
          }
        }

        renderPrices() {
          const p = this.price();
          this.querySelectorAll('[data-hb-total]').forEach((el) => {
            el.textContent = this.money(p * Number(el.dataset.hbTotal));
          });
          // thẻ "Ships free" nằm ở ô đầu tiên vượt ngưỡng
          const tagText = (this.querySelector('.hb-qty__tag') || {}).textContent || this.tagText;
          if (tagText) this.tagText = tagText;
          this.querySelectorAll('.hb-qty__tag').forEach((t) => t.remove());
          if (!this.threshold || !this.tagText || !p) return;
          for (let q = 1; q <= 3; q++) {
            if (p * q >= this.threshold && p * (q - 1) < this.threshold) {
              const tag = document.createElement('span');
              tag.className = 'hb-qty__tag';
              tag.textContent = this.tagText;
              this.tiles[q - 1].prepend(tag);
              break;
            }
          }
        }

        render() {
          const on = Math.min(this.qty, 4);
          this.tiles.forEach((t) => {
            const checked = Number(t.dataset.qty) === on;
            t.setAttribute('aria-checked', String(checked));
            t.tabIndex = checked ? 0 : -1;
          });
          if (this.more) this.more.hidden = this.qty < 4;
          if (this.val) this.val.textContent = String(this.qty);
          if (this.moreTotal) this.moreTotal.textContent = this.money(this.price() * this.qty);
        }
      }
    );
  };
  // định nghĩa khi HTML dựng xong ('interactive' đến trước các script defer), không chờ DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('readystatechange', function hbQtyReady() {
      if (document.readyState === 'loading') return;
      document.removeEventListener('readystatechange', hbQtyReady);
      define();
    });
  } else {
    define();
  }
})();
